var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPickaxe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 2l-8 8-3 3 4 4 3-3 8-8-4-4zm6 6l-4 4-2-2 4-4 2 2zM4 18l2 2-2 2-2-2 2-2zm12-4l-6 6-2-2 6-6 2 2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickaxe);
export default __webpack_public_path__ + "static/media/pickaxe.1415798e51ff9ebad50cd4ac4b5102e0.svg";
export { ForwardRef as ReactComponent };